import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgInfoIconSecondary from './svgs/InfoIconSecondary.js';
import SvgInfoIcon from './svgs/InfoIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var InfoIcon = (props => useIcon(SvgInfoIcon, SvgInfoIconSecondary, props));

export { InfoIcon as default };
